<template lang="pug">
    .p-6(class="custom-shadow rounded-2xl bg-white text-sm")
        slot
</template>

<script>
export default {
    name: "Notification",
}
</script>